export enum PORT_REQUEST_STATUS {
  UNKNOWN,
  CREATED,
  CREATED_DRAFT,
  UPLOADED_FILES,
  SENT,
  DIDS_CREATED,
  TEMP_DIDS_BOUGHT,
  PORTED,
  FOC_RECEIVED,
  CANCELED,
  EXCEPTION,
  COMPLETED,
}
